"use client";

import { useEffect } from "react";

export function PwaRegistrar() {
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const register = () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" })
        .then(() => { document.documentElement.dataset.offlineReady = "true"; })
        .catch(() => {
          document.documentElement.dataset.offlineReady = "false";
          // The game remains playable online when service workers are unavailable.
        });
    };
    if (document.readyState === "complete") {
      register();
      return;
    }
    window.addEventListener("load", register, { once: true });
    return () => window.removeEventListener("load", register);
  }, []);

  return null;
}
